<route>
{
    "name": "changelog",
    "meta": {
        "title": "Versiune actuala si actualizari",
        "requiresAuth": true,
        "permissions": ["manager", "sef_de_unitate"],
        "fail": "/403"
    }
}
</route>
<template>
  <main-layout>
      <v-container grid-list-xl>
          <v-layout wrap>
              <v-row>
                  <v-col>
                      <v-card elevation="0" :loading="loading">
                          <template slot="progress">
                              <v-overlay absolute class="d-flex flex-column text-center">
                                  <div>
                                      <v-progress-circular size="250" width="10" color="primary" indeterminate>
                                          <span>In curs de incarcare...</span>
                                      </v-progress-circular>
                                  </div>
                              </v-overlay>
                          </template>
                          <v-row>
                              <v-col md="12">
                                  <div v-html="changelog"></div>
                              </v-col>
                          </v-row>
                      </v-card>
                  </v-col>
              </v-row>
          </v-layout>
      </v-container>
  </main-layout>
</template>

<script>
import MainLayout from "Layouts/Main.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import ACL from "Mixins/acl";

export default {
    mixins: [ACL],
    components: {
        MainLayout
    },
    data: () => ({
        loading: true,
        changelog: undefined
    }),
    async mounted () {
        await this.loadChangelog()
        this.loading = false
    },
    methods: {
        async loadChangelog() {
            await this.axios.get(route('api.common.changelog')).then(({data}) => {
                this.changelog = data?.content;
            }).catch((err) => {
                this.showError()
            })
            this.loading = true
        }
    }
};
</script>
